export default __webpack_public_path__ + "static/media/supriya-web1.daa4651f.jpg";